'use client';

import { useTravelConfig } from '@/hooks/useTravelConfig';
import { memo } from 'react';

interface LocationIndicatorProps {
  className?: string;
}

export const LocationIndicator = memo(({ className = '' }: LocationIndicatorProps) => {
  const { currentLocation, isLoading, error } = useTravelConfig();

  if (isLoading) {
    return (
      <span className={`text-sm ${className}`}>
        📍 Loading...
      </span>
    );
  }

  if (error || !currentLocation) {
    return (
      <span className={`text-sm text-red-400 ${className}`}>
        📍 Unable to load location
      </span>
    );
  }

  const locationText = currentLocation.isTravel
    ? `✈️ Traveling: ${currentLocation.city}, ${currentLocation.country}`
    : `📍 ${currentLocation.city}, ${currentLocation.country}`;

  return (
    <span
      className={`text-sm ${className}`}
      role="status"
      aria-label={`Current location: ${locationText}`}
    >
      {locationText}
    </span>
  );
});

LocationIndicator.displayName = 'LocationIndicator';
